<template>
  <Layout>
    <p style="font-family: 'Prompt', sans-serif;">สรุปผู้เรียนรายเดือน</p>
    <b-row class="mt-3">
      <b-col lg="12" class="ml-2 d-flex align-items-center">
        <span class="mr-3">ข้อมูลรายเดือน</span>
        <month-picker-input
          style="z-index: 2"
          :default-year="year"
          :default-month="month"
          lang="th"
          @change="filterSearch('begin', $event)"
          :input-pre-filled="true"
          class="mr-4"
        ></month-picker-input>
        <span class="mr-3 ml-1">ถึง</span>
        <month-picker-input
          style="z-index: 2"
          :default-year="year"
          :default-month="month"
          lang="th"
          @change="filterSearch('end', $event)"
          :min-date="
            new Date(fullStartDate.getFullYear(), fullStartDate.getMonth(), 0)
          "
          :input-pre-filled="true"
          class="mr-3"
        ></month-picker-input>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <template v-if="!isTutorType()">
        <b-col md="4">
          <label class="mr-sm-2" for="branch">สาขา</label>
          <div class="mr-sm-2">
            <b-form-select
              id="branch"
              class="mb-2 ml-lg-2 mr-sm-4 mb-sm-0"
              v-model="departmentSelected"
              :options="departmentOptions"
              @input="filterSearch()"
            ></b-form-select>
          </div>
        </b-col>
        <b-col md="4">
          <label class="mr-sm-2" for="group-c">กลุ่มตำแหน่ง </label>
          <div class="mr-sm-2">
            <b-form-select
              id="group-c"
              class="mb-2 ml-lg-2 mr-sm-2 mb-sm-0"
              v-model="groupSelected"
              :options="groupOptions"
              @input="filterSearch()"
            ></b-form-select>
          </div>
        </b-col>
      </template>
      <template v-else>
        <b-col md="4">
          <label class="mr-sm-2" for="branch">โรงเรียน</label>
          <div class="mr-sm-2">
            <b-form-select
              id="branch"
              class="mb-2 ml-lg-2 mr-sm-4 mb-sm-0"
              v-model="educationSelected"
              :options="educationOptions"
              @input="filterSearch()"
            ></b-form-select>
          </div>
        </b-col>
      </template>
      <b-col md="4">
        <label class="mr-sm-2" for="courseName">ค้นหาคอร์ส </label>
        <v-select
          v-if="courses != null"
          :options="courses"
          label="courseName"
          v-model="courseData"
          placeholder="กรุณาพิมพ์เพื่อค้นหาชื่อหลักสูตร..."
          :clearable="false"
          @input="filterSearch()"
        />
        <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
      </b-col>
    </b-row>
    <br />
    <div :key="reloadKey">
      <b-row>
        <TotalLearningStatByHour
          :begin="begin"
          :end="end"
          :dep="departmentSelected"
          :edu="educationSelected"
          :group="groupSelected"
          :course="courseData.courseId"
          statType="month"
        />
      </b-row>
      <br />
      <b-row>
        <b-col lg="6">
          <TotalLearningStatByPeriod
            :begin="begin"
            :end="end"
            :dep="departmentSelected"
            :edu="educationSelected"
            :group="groupSelected"
            :course="courseData.courseId"
            statType="month"
          />
        </b-col>
        <b-col lg="6">
          <TotalLearningStatByDay
            :begin="begin"
            :end="end"
            :dep="departmentSelected"
            :edu="educationSelected"
            :group="groupSelected"
            :course="courseData.courseId"
            statType="month"
          />
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/pages/analytics/shared/Layout.vue";
import TotalLearningStatByHour from "@/components/pages/analytics/user/overview/panel/TotalLearningStatByHour.vue";
import TotalLearningStatByPeriod from "@/components/pages/analytics/user/overview/panel/TotalLearningStatByPeriod.vue";
import TotalLearningStatByDay from "@/components/pages/analytics/user/overview/panel/TotalLearningStatByDay.vue";
import api from "@/services/api.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { MonthPickerInput } from "vue-month-picker";
import AuthMixin from "@/mixins/auth-mixin.js";

export default {
  components: {
    Layout,
    TotalLearningStatByHour,
    TotalLearningStatByPeriod,
    TotalLearningStatByDay,
    vSelect,
    MonthPickerInput
  },
  mixins: [AuthMixin],
  props: {
    company: Object
  },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      departmentSelected: "*",
      departmentOptions: [],
      educationSelected: "*",
      educationOptions: [],
      groupSelected: "*",
      groupOptions: [],
      userRoles: [],
      courses: null,
      courseData: "กรุณาพิมพ์เพื่อค้นหาชื่อหลักสูตร...",
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      begin: this.convertDateFormat(new Date()),
      end: this.convertDateFormat(new Date()),
      fullStartDate: new Date(),
      fullEndDate: new Date(),
      reloadKey: 0,
      dateSelected: null
    };
  },
  async created() {
    this.setUserRole();
    this.setDepartmentOptions();
    this.setEducationOptions();
    this.setGroupOptions();
    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      this.courses = data.data;
    });
  },
  methods: {
    setUserRole() {
      this.userRoles = this.$store.state.Authentication.authUser.roles
        .filter(el => el.companyId === this.company.id)
        .filter(
          el =>
            el.roleName.substring(0, 5) === "tutor" ||
            el.roleName.substring(0, 3) === "org"
        )
        .map(el => el.roleName);
    },
    hasRoles(roles) {
      for (let role of roles) {
        if (this.userRoles.includes(role)) return true;
      }
      return false;
    },
    async setDepartmentOptions() {
      try {
        // Fetch the company departments from backend
        let results = await api.get(
          `/v1/companies/${this.company.id}/departments`
        );
        this.departmentOptions = results.data.map(el => {
          // Handle null case
          if (!el) {
            return { value: "null", text: "ไม่มี" };
          }
          return { value: el.replace(/ /g, "!"), text: el };
        });
        // Add the total option in the first place
        this.departmentOptions.unshift({
          value: "*",
          text: "ทั้งหมด"
        });
      } catch (err) {
        console.log("setDepartmentOptions error", err);
      }
    },
    async setEducationOptions() {
      try {
        // Fetch the company educations from backend
        let results = await api.get(
          `/v1/companies/${this.company.id}/educations`
        );
        this.educationOptions = results.data.map(el => {
          // Handle null case
          if (!el) {
            return { value: "null", text: "ไม่มี" };
          }
          return { value: el.replace(/ /g, "!"), text: el };
        });
        // Add the total option in the first place
        this.educationOptions.unshift({
          value: "*",
          text: "ทั้งหมด"
        });
      } catch (err) {
        console.log("setEducationOptions error", err);
      }
    },
    async setGroupOptions() {
      try {
        // Fetch the company groups from backend
        let results = await api.get(`/v1/companies/${this.company.id}/groups`);
        this.groupOptions = results.data.data.map(el => {
          return { value: el.id + "", text: el.name };
        });
        // Add the total option in the first place
        this.groupOptions.unshift({
          value: "*",
          text: "ทั้งหมด"
        });
      } catch (err) {
        console.log("setGroupOptions error", err);
      }
    },
    async filterSearch(type = null, value = null) {
      if (type == "begin") {
        this.begin = this.convertDateFormat(value.from);
        this.fullStartDate = value.from;
        if (
          this.fullEndDate.getFullYear() != this.fullStartDate.getFullYear() ||
          (this.fullEndDate.getFullYear() == this.fullStartDate.getFullYear() &&
            this.fullEndDate < this.fullStartDate)
        ) {
          this.fullEndDate = this.fullStartDate;
          this.end = this.convertDateFormat(this.fullStartDate);
          this.year = this.fullStartDate.getFullYear();
          this.month = this.fullStartDate.getMonth() + 1;
        }
      } else if (type == "end") {
        this.end = this.convertDateFormat(value.from);
        this.fullEndDate = value.from;
        if (
          this.fullEndDate.getFullYear() != this.fullStartDate.getFullYear() ||
          (this.fullEndDate.getFullYear() == this.fullStartDate.getFullYear() &&
            this.fullEndDate < this.fullStartDate)
        ) {
          this.fullStartDate = this.fullEndDate;
          this.begin = this.convertDateFormat(this.fullEndDate);
          this.year = this.fullEndDate.getFullYear();
          this.month = this.fullEndDate.getMonth() + 1;
        }
      }
      this.reloadKey += 1;
    },
    convertDateFormat(date) {
      const pad = n => n.toString().padStart(2, "0");
      let yyyy = date.getFullYear();
      let mm = pad(date.getMonth() + 1);
      let dd = pad(date.getDate());
      return `${yyyy}-${mm}-${dd}`;
    }
  }
};
</script>

<style>
.month-picker__year {
  padding: 1.2rem;
}
</style>